import type { ReactNode } from 'react';
import { Flex, Spin } from 'antd';
import { useLocation } from 'react-router-dom';

import { AppErrorPage } from '../components/common/AppError';
import { useSessionBootstrap } from '../hooks/useSessionBootstrap';
import { useAuthStore } from '../store/useAuthStore';
import { isPublicBootstrapBypassPath } from '../utils/publicAuthPaths';

const SessionGate = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const { sessionLoading } = useSessionBootstrap();
  const bootstrapServerError = useAuthStore((state) => state.bootstrapServerError);
  const bootstrapSupportCode = useAuthStore((state) => state.bootstrapSupportCode);
  const retryBootstrapSession = useAuthStore((state) => state.retryBootstrapSession);
  const isPublicEntry = isPublicBootstrapBypassPath(pathname);

  if (bootstrapServerError) {
    return (
      <AppErrorPage
        variant="server"
        layout="fullPage"
        supportCode={bootstrapSupportCode ?? undefined}
        onRetry={() => {
          void retryBootstrapSession();
        }}
      />
    );
  }

  if (sessionLoading && !isPublicEntry) {
    return (
      <Flex justify="center" align="center" style={{ height: '100vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return <>{children}</>;
};

export default SessionGate;
